import { useClientConfigProvider } from "@/app/config/client-config-provider";
import React from "react";
import FAQV1 from "./v1/v1";
import FAQV2 from "./v2/v2";

function FAQPage() {
  const { config } = useClientConfigProvider();
  if (config?.designVersion === "v1") {
    return <FAQV1 />;
  }
  if (config?.designVersion === "v2") {
    return <FAQV2 />;
  }
}

export default FAQPage;
